export function setupErrorHandler() {
    window.addEventListener('error', (event) => {
        const errorDiv = document.createElement('div');
        errorDiv.style.position = 'fixed';
        errorDiv.style.top = '0';
        errorDiv.style.left = '0';
        errorDiv.style.width = '100%';
        errorDiv.style.padding = '20px';
        errorDiv.style.backgroundColor = 'rgba(255, 0, 0, 0.9)';
        errorDiv.style.color = 'white';
        errorDiv.style.zIndex = '999999';
        errorDiv.style.fontSize = '16px';
        errorDiv.style.fontFamily = 'monospace';
        errorDiv.innerHTML = `
      <h3>JavaScript Error</h3>
      <p><strong>Message:</strong> ${event.message}</p>
      <p><strong>File:</strong> ${event.filename}:${event.lineno}:${event.colno}</p>
      <pre>${event.error?.stack || ''}</pre>
    `;
        document.body.appendChild(errorDiv);
    });
    window.addEventListener('unhandledrejection', (event) => {
        const errorDiv = document.createElement('div');
        errorDiv.style.position = 'fixed';
        errorDiv.style.top = '0';
        errorDiv.style.left = '0';
        errorDiv.style.width = '100%';
        errorDiv.style.padding = '20px';
        errorDiv.style.backgroundColor = 'rgba(255, 100, 0, 0.9)';
        errorDiv.style.color = 'white';
        errorDiv.style.zIndex = '999999';
        errorDiv.style.fontSize = '16px';
        errorDiv.style.fontFamily = 'monospace';
        errorDiv.innerHTML = `
      <h3>Unhandled Promise Rejection</h3>
      <p><strong>Reason:</strong> ${event.reason}</p>
      <pre>${event.reason?.stack || ''}</pre>
    `;
        document.body.appendChild(errorDiv);
    });
}
